import "bootstrap/dist/css/bootstrap.min.css";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Tooltip,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";
import { CiDeliveryTruck } from "react-icons/ci";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  ChartDataLabels
);

const TireCostByVehicle = ({ vehicleData = [] }) => {
  const labels = vehicleData.map((item) => item.vehicle?.registration_number);
  const dataValues = vehicleData.map((item) => Number(item.total_tire_cost));

  const data = {
    labels,
    datasets: [
      {
        label: "Total Cost (₨)",
        data: dataValues,
        backgroundColor: "#38bdf8",
        hoverBackgroundColor: "#0ea5e9",
        borderRadius: 6,
        barThickness: 40,
        categoryPercentage: 0.6,
        barPercentage: 0.8,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    layout: {
      padding: {
        top: 30, // Prevents label clipping
      },
    },
    plugins: {
      legend: { display: false },
      datalabels: {
        anchor: "end",
        align: "end",
        color: "#4F19E2",
        font: {
          weight: "bold",
          size: 9,
        },
        formatter: (value) => `Rs ${value.toLocaleString()}`,
      },
      tooltip: {
        callbacks: {
          label: (context) => `Rs ${Number(context.raw).toLocaleString()}`,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          display: true,
          callback: function (value) {
            return "Rs " + value.toLocaleString();
          },
        },
        grid: { drawTicks: true },
        title: {
          display: true,
          text: "Cost (₨)",
        },
      },
      x: {
        title: {
          display: true,
          text: "Vehicle Registration No.",
        },
        ticks: {
          autoSkip: false,
          maxRotation: 45,
          minRotation: 45,
        },
      },
    },
  };

  const dynamicWidth = `${labels.length * 80}px`;

  return (
    <div className="card_container">
      <h5 className="mb-3 scheduled_unscheduled_heading">
        <CiDeliveryTruck size={30} className="me-2" color="#4F19E2" />
        Tire Cost by Vehicle
      </h5>
      <hr />
      {vehicleData.length === 0 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "250px",
            color: "#666",
            fontSize: "18px",
            textTransform: "capitalize"
          }}
        >
          No data found
        </div>
      ) : (
        <div className="overflow-auto">
          <div
            style={{
              width: dynamicWidth,
              height: "400px",
            }}
          >
            <Bar data={data} options={options} plugins={[ChartDataLabels]} />
          </div>
        </div>
      )}
    </div>
  );
};

export default TireCostByVehicle;
